import React from 'react';
import { Redirect } from "react-router-dom";

import { Page } from './page';

import "../styles/endscore.css";

import Player from '../functions/player';
import API from '../functions/api';

import { EntitiesArray } from '../components/island';
import { Score } from '../components/score';
import { Restore } from '../components/restore';

var reloaded = false;

export class Endscore extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      partOfGame: 13,
      timerOver: false,
      fireRedirect: false,
      redirectLeaderboard: false,
      scoreBtnVal: 'Publiceer score van de klas en check de klassenranglijst *',
      finished: false,
      addScores: this.addScores()
    }
  }

  addScores(){
    if(EntitiesArray[0].round === 0 || reloaded) {
      reloaded = true;
      let scores = [];
      for (var i2 = 0; i2 < EntitiesArray.length; i2++) {
        scores.push(<Score show={false} endscore={true} key={'key_' + i2 } dataKey={i2} data={EntitiesArray[i2]}/>);
      };
      this.setState({
        finished: true,
      })

      return scores;
    } else {
      let scores = [];
      for (var i = 0; i < EntitiesArray.length; i++) {
        scores.push(<Score show={false} endscore={false} key={'key_' + i } dataKey={i} data={EntitiesArray[i]}/>);
      };
      this.setState({
        finished: true,
      })
      return scores;
    }

  }

  renderScores(){
    var byScore = EntitiesArray.slice(0);
    byScore.sort(function(a, b){
      return (b.score === a.score) ? 0 : (a.score > b.score ? -1 : 1);
    });

    byScore.forEach(function(outer) {
      outer.entitiesWithSameScore = byScore.filter(function(inner) {
        return Math.round(outer.score) === Math.round(inner.score);
      }).filter(function(inner) {
        return inner !== outer;
      }).map(function(inner) {
        return inner.name;
      });
    });

    let displayPosition = 0;
    byScore.forEach(function(current, actualPosition) {
      const hasDuplicate = current.entitiesWithSameScore.length !== 0;
      if (hasDuplicate) {
        current.displayPosition = displayPosition + 1;
      } else {
        displayPosition = actualPosition + 1;
        current.displayPosition = displayPosition;
      }
    });

    var finalScores = [];
    for (var d = 0; d < byScore.length; d++) {
      finalScores.push(<Score show={true} key={'key_' + d } endscore={true} dataKey={d} data={byScore[d]}/>);
    }

    return finalScores;
  }

  componentWillMount(){
    var currentLocation = this.props.location.pathname;
    Player.storeData('localRoute', currentLocation);

    this.setState({
      addScores: this.addScores(),
    })
  }

  componentDidMount(){
    if (this.state.finished) {
      this.setState({
        scores: this.renderScores(),
      })

      let sessionCode = Player.getCookie('sessionID');

      // Send a POST request
      setTimeout(function(){
        API.post('/?action=updateTime', {
          code: sessionCode,
          elapsed: {
            minutes: 0,
            seconds: 0,
            round: 3,
            route: '/endscore',
            part: 13,
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      }, 1000);
    }
  }

  getGlobalScore = () => {
    let globals = {
      globalScore: 0,
      powerNeeded: 0,
      greenEnergy: 0,
    }

    if(EntitiesArray[0].round === 0) {
      return globals;
    }

    for (let i = 0; i < EntitiesArray.length; i++) {
      const element = EntitiesArray[i];
      globals.globalScore += element.score;
      globals.powerNeeded += element.getMwuServices();
      globals.greenEnergy += element.getMwuGreen();
    }

    return globals;
  }

  handleScores = () => {
    if (this.state.scoreBtnVal === 'Scores verstuurd!') {
      return;
    }
    const session = Player.getCookie('sessionID');

    const globals = this.getGlobalScore();

    this.setState({
      scoreBtnVal: 'Scores verstuurd!',
    })

    // Send a POST request
    API.post('/?action=postScore', {
      score: globals.globalScore,
      necessities: globals.powerNeeded,
      mwuGreen: globals.greenEnergy,
      code: session,
    })
    .then(function (response) {
      //console.log(response);
      Player.eraseCookie('sessionID');
      window.location.replace("https://youvegotthepower.nl/pages/ranglijst");
    })
    .catch(function (error) {
      console.log(error);
    });

  }

  handleEndGame = () => {
    Player.eraseCookie('sessionID');
    this.setState({
      fireRedirect: true,
    })
    window.location.reload(true);
  }

  render() {
    const classScore = this.getGlobalScore();
    return(
      <Page type="endScore" width="superWide" pageTitle="Eindscore" imgSet="4">
      <Restore/>
        <div>
          {this.state.addScores }
          {this.state.scores}
        </div>

        <div className="endgame_actions">
          <button className="btn post-scores" onClick={ () => this.handleScores() } type="button"> {this.state.scoreBtnVal}</button>
          <button className="btn end-game" onClick={ () => this.handleEndGame() } type="button"> Spel beeindigen</button>
          <div className="endgame_classScore">
            <div className="scoreBubble scoreBubble--score">
              Score <span>{classScore.globalScore.toFixed(0)}</span>
            </div>
            <div className="scoreBubble scoreBubble--need">
              Voorziening <span>{classScore.powerNeeded.toFixed(0)}MWU</span>
            </div>
            <div className="scoreBubble scoreBubble--green">
              Groene stroom <span>{classScore.greenEnergy.toFixed(0)}MWU</span>
            </div>
          </div>
        </div>
        {this.state.fireRedirect && (<Redirect to="/"/>)}
        {this.state.redirectLeaderboard && (<Redirect to="/leaderboard"/>)}
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/endscore.js